function clearSessionStorageOnLoad() {
    sessionStorage.clear();
  }
  window.onload = clearSessionStorageOnLoad;

  function switchGridColTwo() {
    document.querySelector('.grid-custom').classList.add('grid-small');
    document.querySelector('.grid-custom').classList.remove('grid-large');
    document.querySelector('.two_column_grid_desk').style.opacity = '100%';
    document.querySelector('.three_column_grid_desk').style.opacity = '35%';
    sessionStorage.setItem('desktop_grid_col', '2');
  }

  function switchGridColThree() {
    document.querySelector('.grid-custom').classList.add('grid-large');
    document.querySelector('.grid-custom').classList.remove('grid-small');
    document.querySelector('.three_column_grid_desk').style.opacity = '100%';
    document.querySelector('.two_column_grid_desk').style.opacity = '35%';
    sessionStorage.setItem('desktop_grid_col', '3');
  }

  function switchGridColOne() {
    document.querySelector('.grid-custom').classList.add('grid-small');
    document.querySelector('.grid-custom').classList.remove('grid-large');
    document.querySelector('.one_column_grid_mob').style.opacity = '100%';
    document.querySelector('.two_column_grid_mob').style.opacity = '35%';
    sessionStorage.setItem('mob_grid_col', '1');
  }

  function switchGridColTwoMob() {
    document.querySelector('.grid-custom').classList.add('grid-large');
    document.querySelector('.grid-custom').classList.remove('grid-small');
    document.querySelector('.two_column_grid_mob').style.opacity = '100%';
    document.querySelector('.one_column_grid_mob').style.opacity = '35%';
    sessionStorage.setItem('mob_grid_col', '2');
  }

  function toggleFilterVisibility() {
    let filterSection = document.querySelector('aside.facets-wrapper-collection');
    if (filterSection.style.display == '' || filterSection.style.display == 'none'){
      filterSection.style.display = 'block';
      document.querySelector('.filter_visibility_label').textContent = "Hide Filters";
    }
    else{
      filterSection.style.display = 'none';
      document.querySelector('.filter_visibility_label').textContent = "Show Filters";
    }
  }


  //Close the product info block when clicked anywhere on screen, except teh product card, size chart drawer close button
  document.addEventListener('click', function(event) {
    let showDetailsBlock = document.querySelector('.show_details');
    let showBtn = document.querySelectorAll('.btn_show_details');
    let cardWrappers = document.querySelectorAll('.card-wrapper.product-card-wrapper');
    let drawerCloseBtn = document.querySelector('.close');
    

    // Convert NodeList to Array for better compatibility with contains()
    showBtn = Array.from(showBtn);
    cardWrappers = Array.from(cardWrappers); 

    // Check if the clicked target is not within any '.btn_show_details'
    if (!showBtn.some(btn => btn.contains(event.target)) && !cardWrappers.some(wrapper => wrapper.contains(event.target)) && event.target !== drawerCloseBtn ) {
    
      if(showDetailsBlock){
        showDetailsBlock.classList.add('hide_details');
        showDetailsBlock.classList.remove('show_details');
        showDetailsBlock.closest('.card__inner_custom').querySelector('.btn_show_details').style.display = "grid";
      }

      //In mobile, hide the bg on product card
      if (window.matchMedia('(max-width: 600px)').matches) {
        let mobCardBg = document.querySelectorAll('.bg-mobile');
        mobCardBg.forEach(bg => {
          if (bg.style.display === 'block') {
              bg.style.display = 'none';
          }
      });
     
      }
    }
});